import { segment, hotjar } from '@hotjar/tracking';
import { keysToSnakeCase } from '@hotjar/webapp/lib/convert-string';
import type { ProductType } from '@hotjar/webapp/domains/common/product/types';
import type { FeatureGroup } from '@hotjar/webapp/domains/revenue/plan/types';
import type { OwnedAccount, SiteAccount } from '@hotjar/account';
import { extractAccountGroupingProps } from '@hotjar/webapp/tracking/utils';

interface UpsellFlowEnteredProperties {
  account: SiteAccount | OwnedAccount;
  entryPoint: string;
}

interface UpsellFlowStepStartedProperties {
  account: SiteAccount | OwnedAccount;
  stepName: string;
  tierRecommended?: FeatureGroup;
  allowanceRecommended?: number;
}

interface UpsellFlowStepFinishedProperties {
  account: SiteAccount | OwnedAccount;
  stepName: string;
  productSelected?: Array<ProductType>;
  tierSelected?: FeatureGroup;
  allowanceSelected?: number;
}

interface UpsellFlowExitedProperties {
  account: SiteAccount | OwnedAccount;
}

const trackUpsellFlowEvent = (
  trackingKey: string,
  properties:
    | UpsellFlowEnteredProperties
    | UpsellFlowStepStartedProperties
    | UpsellFlowStepFinishedProperties
    | UpsellFlowExitedProperties,
): void => {
  const { account, ...rest } = properties;
  const data = {
    ...extractAccountGroupingProps(account),
    ...keysToSnakeCase(rest),
  };

  segment.track(trackingKey, data);
  hotjar.tagRecording(trackingKey);
};

export const upsellFlowEntered = (properties: UpsellFlowEnteredProperties): void => {
  trackUpsellFlowEvent('Upsell Flow Entered', properties);
};

export const upsellFlowStepStarted = (properties: UpsellFlowStepStartedProperties): void => {
  trackUpsellFlowEvent('Upsell Flow Step Started', properties);
};

export const upsellFlowStepFinished = (properties: UpsellFlowStepFinishedProperties): void => {
  trackUpsellFlowEvent('Upsell Flow Step Finished', properties);
};

export const upsellFlowExited = (properties: UpsellFlowExitedProperties): void => {
  trackUpsellFlowEvent('Upsell Flow Exited', properties);
};
